
import * as _ from "lodash";
import { DocumentIsogd, DocumentTerritoryArea, DocumentTerritoryDistrict } from "isogd-document-rest";

class DocumentTerritoryViewController {
    private document: DocumentIsogd;

    getAreaString(areas: DocumentTerritoryArea[]): string {
        if (areas) {
            return _.map(areas, (area) => {
                return area.areaName;
            }).join(', ');
        }
    }

    getDistrictString(districts: DocumentTerritoryDistrict[]): string {
        if (districts) {
            return _.map(districts, (district) => {
                return district.districtName;
            }).join(', ');
        }
    }
}

export const DocumentTerritoryViewComponent: angular.IComponentOptions = {
    controller: DocumentTerritoryViewController,
    template: require('./documentTerritoryView.html'),
    bindings: {
        document: "<"
    }
};


// WEBPACK FOOTER //
// ./src/components/document/document-territory/documentTerritoryView.ts